// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__vE3Nh","row":"Node_row__3cKmb","label":"Node_label__P7WOF","footer":"Node_footer__q9Myw"};